import React, { useEffect } from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useDropdown } from 'core/hooks/useDropdown';
import { useGetSlideMessage } from './hooks/useGetSlideMessage';
import { CSSTransition } from 'react-transition-group';

import './SlideMessage.scss';

function SlideMessage({ step }) {
  const { hideSubnav, toggleSubnav, isFocused } = useDropdown();
  const { data } = useGetSlideMessage({ step });

  const { disclaimer, preTitle, title } = data;

  useEffect(() => {
    if (title) {
      const element = document.querySelector('.mn_onboarding .mn_slide');
      element?.classList.add('mn_hasMessage');
    }
  }, [data]);

  if (!title) return null;

  return (
    <div className="mn_slideMessage">
      <div className="mn_details">
        {preTitle && <div className="mn_preTitle" dangerouslySetInnerHTML={{ __html: preTitle }} />}
        <div className="mn_title" dangerouslySetInnerHTML={{ __html: title }} />
        {disclaimer &&
          <button
            className="mn_basicButton mn_showDisclaimerButton"
            onClick={() => toggleSubnav(isFocused)}
          >
            View terms and conditions&nbsp;&nbsp;
            <span className="mn_icon" aria-hidden="true">{isFocused ? <>&#xf106;</> : <>&#xf107;</>}</span>
          </button>
        }
      </div>
      {disclaimer &&
        <CSSTransition in={isFocused} appear timeout={200} classNames="mn_animation" unmountOnExit>
          <div className="mn_disclaimerWrap">
            <div className="mn_disclaimer" dangerouslySetInnerHTML={{ __html: disclaimer }} />
            <button className="mn_basicButton mn_hideDisclaimerButton" onClick={hideSubnav}>
              Close&nbsp;&nbsp;<span className="mn_icon" aria-hidden="true">&#xf106;</span>
            </button>
          </div>
        </CSSTransition>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><SlideMessage {...props} /></ComponentErrorBoundary>;
